import { Injectable, Inject, OnDestroy, NgZone } from '@angular/core';
import { MMConfig, MM_CONFIG } from '@docma-mm-core/config/mm.config';
import { AppContainerService, AppContainerOptions, SideNavBarService } from '@mydocma/app-container';
import { Router, ActivatedRoute } from '@angular/router';
import { Project as MmProject } from '@docma-mm-core/project/project';
import { BehaviorSubject } from 'rxjs';
import { MmProjectService } from './mm-project/mm-project.service';
import { MmSideNavBarButtonsEnum } from './mm-sidenavbar/mm-sidenavbar-buttons.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MmRoutingService } from './mm-routing/mm-routing.service';

@UntilDestroy()
@Injectable()
export class MmViewService implements OnDestroy {

  public currentProjectSubject = new BehaviorSubject<MmProject>(null);
  public currentProject$ = this.currentProjectSubject.asObservable();

  constructor(@Inject(MM_CONFIG) private config: MMConfig,
              private readonly router: Router,
              private readonly sideNavBarService: SideNavBarService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly projectService: MmProjectService,
              private readonly appContainerService: AppContainerService,
              private readonly routingService: MmRoutingService) {

  this.projectService.currentProject
    .pipe(untilDestroyed(this))
    .subscribe(p => {
        console.debug('MmViewService: Project changed');
        console.debug(p);
        this.currentProjectSubject.next(p);
      });
  }

  ngOnDestroy(): void {
  }

  public closeFilter() {
    this.appContainerService.closeContentSideNav();
    this.sideNavBarService.collapseButton(MmSideNavBarButtonsEnum.FilterGroup);
  }


  getConfig(): MMConfig {
    return this.config;
  }

  register(appContainer: AppContainerOptions, buttons: any[] = []) {
    appContainer.header.customerSelection = false;
    appContainer.header.projectSelection = true;
    appContainer.header.userMenuItems.shouldShowLogs = false;
    appContainer.rightDrawer.visibleRightDrawerContentId = null;
    appContainer.sideNavBar.classes = ['my-mm-side-nav'];
  }

  unregister(appContainer: AppContainerOptions) {
  }


  registerView(component) {
    if (this.appContainerService) {
      this.appContainerService.registerFrameComponent(component);
    }
  }

  unregisterView(component) {
    if (this.appContainerService) {
      this.appContainerService.unregisterFrameComponent(component);
    }
  }


  startProjectSelection(returnUrl: string) {
    this.routingService.navigate(['projects'], { relativeTo: this.activatedRoute, queryParams: { returnUrl } });
  }

}
